import React from "react";

const styles = {
  heading: {
    color: "orange",
    fontWeight: "bold",
    marginTop: "1rem",
    textDecoration: "underline",
    marginBottom: "1rem",
  },
  answer: {
    fontWeight: "bold",
    fontSize: "0.7rem",
    marginTop: "0.2rem",
  },
  userName: {
    fontSize: "0.8rem",
  },
  listItem: {
    borderBottom: "1px solid #e9e9e9",
    paddingBottom: "0.5rem",
  },
};
export default ({ responses }) => {
  const classes = styles;
  if (responses.length === 0) {
    return <></>;
  }
  return (
    <div>
      <div style={classes.heading}>Team Responses</div>
      {responses.map((res) => (
        <div style={classes.listItem}>
          <div style={classes.userName}>{res.name}</div>
          <div style={classes.answer}>{res.answer}</div>
        </div>
      ))}
    </div>
  );
};
